document.addEventListener('DOMContentLoaded', () => {

  if (document.querySelector('.copy-link .button')) {
    document.querySelector('.copy-link .button').addEventListener('click', function() {
      let copyText = document.getElementById("clipboard");
      /* Select the text field */
      copyText.select();
      copyText.setSelectionRange(0, 99999); /* For mobile devices */
      /* Copy the text inside the text field */
      navigator.clipboard.writeText(copyText.value);
      let x = document.getElementById("snackbar");
      x.className = "show";
      setTimeout(function(){ x.className = x.className.replace("show", ""); }, 3000);
    })
  }


}, {passive: true});
